<template>
  <div class="qa-container">
    <div
      :style="`color: ${isCollapsed ? 'black': 'var(--primary)'} !important`"
      class="qa-controller"
      @click="isCollapsed = !isCollapsed"
    >
      <i
        v-if="isCollapsed"
        class="fa fa-chevron-right"
      />
      <i
        v-else
        class="fa fa-chevron-down"
      />
    </div>
    <div class="qa-content">
      <div class="row">
        <div
          :style="`color: ${isCollapsed ? 'black': 'var(--primary)'}`"
          class="question col-md-12"
        >
          <span @click="isCollapsed = !isCollapsed">
            <slot name="question" />
          </span>
        </div>
        <div
          v-show="!isCollapsed"
          class="col-md-12 answer content-weight"
        >
          <slot name="answer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleQA',
  props: {
    collapsed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isCollapsed: this.collapsed
    }
  }
}
</script>

<style scoped>
.qa-container > div {
  display: inline-block;
}

.qa-controller:hover, .question > span:hover {
  color: var(--primary);
  cursor: pointer;
}

.qa-controller {
  width: 30px;
}

.qa-content {
  width: calc(100% - 30px);
}

.question {
  margin-bottom: 20px;
}

.answer {
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 20px;
  color: #3c3c3c;
}
</style>
